import axios from "axios";
import { API } from "@/lib/api";

export const TOKEN_KEY = "atl_member_token";

export const shopApi = axios.create({ baseURL: API });

shopApi.interceptors.request.use((config) => {
  const token = sessionStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

shopApi.interceptors.response.use(
  (res) => res,
  (err) => {
    const url = err.config?.url || "";
    if (err.response?.status === 401 && !url.includes("/member/auth/login")) {
      sessionStorage.removeItem(TOKEN_KEY);
      if (!["/", "/login", "/register"].includes(window.location.pathname)) window.location.href = "/login?expired=1";
    }
    return Promise.reject(err);
  }
);

export const STATUS_META = {
  pending: { label: "Awaiting payment", cls: "bg-amber-50 text-amber-800 border-amber-200" },
  payment_received: { label: "Payment received", cls: "bg-sky-50 text-sky-800 border-sky-200" },
  processing: { label: "Processing", cls: "bg-indigo-50 text-indigo-800 border-indigo-200" },
  shipped: { label: "Shipped", cls: "bg-blue-50 text-blue-800 border-blue-200" },
  completed: { label: "Completed", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  cancelled: { label: "Cancelled", cls: "bg-rose-50 text-rose-700 border-rose-200" },
};

export const productLabel = (p) => `${p.name}${p.size ? " " + p.size : ""}`;
